import { Injectable, Signal, signal } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class HelpService {
    private _isHelpVisible = signal<boolean>(false)

    public getIsHelpVisible(): Signal<boolean> {
        return this._isHelpVisible
    }

    public setIsHelpVisible(value: boolean): void {
        this._isHelpVisible.set(value)
    }

    public openHelp(): void {
        this._isHelpVisible.set(true)
    }

    public closeHelp(): void {
        this._isHelpVisible.set(false)
    }
}
